//export files in module folders
import datafileMapper from "./datafileMapper";
import activityMapper from "./activityMapper";
import invaliddatafileMapper from "./invaliddatafileMapper";
import deletefilelogsMapper from "./deletefilelogsMapper";
import projectMapper from "./projectMapper";
import organizationMapper from "./organizationadministrationMapper";
import userMapper from "./userMapper";
import offsettingaccountMapper from "./offsettingaccountMapper";
import salesbycountryMapper from "./salesbycountryMapper";
import taxonomyanomalyMapper from "./taxonomyanomalyMapper";
import generatordatafileMapper from "./generatordatafileMapper";
import genericviewMapper from "./genericviewMapper";
import auditnoterecordMapper from "./auditnoterecordMapper";
import auditnoteMapper from "./auditnoteMapper";
import ncrulefindingMapper from "./ncrulefindingMapper";
import ncfindingMapper from "./ncfindingMapper";
import ncruleMapper from "./ncruleMapper";
import datafilesubmissionMapper from "./datafilesubmissionMapper";
import ncauditexecutionsummaryMapper from "./ncauditexecutionsummaryMapper";
import nctrialbalanceMapper from "./nctrialbalanceMapper";
import ncauditerrorMapper from "./ncauditerrorMapper";
import ncstatementaccountaccumulatedMapper from "./ncstatementaccountaccumulatedMapper";
import ncoffsettingaccountMapper from "./ncoffsettingaccountMapper";
import repositorymetadataMapper from "./repositorymetadataMapper";
import balancesheetMapper from "./balancesheet";
import profitandlossMapper from "./profitandlossMapper";
import nctrialbalancetaxonomypluriannualMapper from "./nctrialbalancetaxonomyplurianual";
import nctrialbalancetaxonomyMapper from "./nctrialbalancetaxonomyMapper";
import nctrialbalancepluriannualMapper from "./nctrialbalancepluriannualMapper";
import customreportMapper from "./customreportMapper";
import factcustomMapper from "./factcustomMapper";
import kpiMapper from "./kpiMapper";
import customreportsettingsMapper from "./CustomReportSettingsMapper";
import packageMapper from "./packagesMapper";
import packagesassociationkpisMapper from "./packagesassociationkpisMapper";
import packagesassociationrulesMapper from "./packagesassociationrulesMapper";
import packagesassociationcustomreportsMapper from "./packagesassociationcustomreportsMapper";
import ncschemafindingMapper from "./ncschemafindingMapper.js";
import translationtableMapper from "./translationTableMapper";
import translationtableupdatelogMapper from "./translationTableUpdateLogMapper";
import mergehistoryMapper from "./mergeHistoryMapper";
import importprofileMapper from "./importProfilesMapper";
import importprofilemappinglogMapper from "./dataSyncLogMapper";
import saftAoBalancesheetMapper from "./saft_ao/balancesheet";
import saftAoProfitandlossMapper from "./saft_ao/profitandloss";

const saft_ao = {
    balancesheetMapper: saftAoBalancesheetMapper,
    profitandlossMapper: saftAoProfitandlossMapper,
};

export {
    packagesassociationkpisMapper,
    ncauditerrorMapper,
    activityMapper,
    datafileMapper,
    invaliddatafileMapper,
    projectMapper,
    organizationMapper,
    taxonomyanomalyMapper,
    userMapper,
    offsettingaccountMapper,
    salesbycountryMapper,
    deletefilelogsMapper,
    generatordatafileMapper,
    genericviewMapper,
    auditnoterecordMapper,
    auditnoteMapper,
    ncrulefindingMapper,
    ncfindingMapper,
    ncruleMapper,
    datafilesubmissionMapper,
    ncauditexecutionsummaryMapper,
    nctrialbalanceMapper,
    ncstatementaccountaccumulatedMapper,
    ncoffsettingaccountMapper,
    repositorymetadataMapper,
    balancesheetMapper,
    profitandlossMapper,
    nctrialbalancetaxonomypluriannualMapper,
    nctrialbalancetaxonomyMapper,
    nctrialbalancepluriannualMapper,
    customreportMapper,
    factcustomMapper,
    kpiMapper,
    customreportsettingsMapper,
    packageMapper,
    packagesassociationrulesMapper,
    packagesassociationcustomreportsMapper,
    ncschemafindingMapper,
    translationtableMapper,
    translationtableupdatelogMapper,
    mergehistoryMapper,
    importprofileMapper,
    importprofilemappinglogMapper,
    saft_ao,
};
